"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "broadcastSyncedServerTime", {
  enumerable: true,
  get: function get() {
    return _broadcastSyncedServerTime["default"];
  }
});
var _broadcastSyncedServerTime = _interopRequireDefault(require("./broadcastSyncedServerTime"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }